export enum WalletTypeIdEnum {
  REAL = 1,
  DEMO = 2,
  BONUS = 3,
  BONUS_PIECES = 4,
  FREE_COINS = 5,

  QUEST_WALLET_1 = 500,
  QUEST_WALLET_2 = 501,

  EVENT_WALLET_1 = 502,

  SEASON_BRONZE_TICKET = 600,
  SEASON_SILVER_TICKET = 601,
  SEASON_GOLD_TICKET = 602,
  SEASON_DIAMOND_TICKET = 603,
}
